import * as React from 'react'

const Membership = (props: { className: 'string' }) => {
  return (
    <svg className={'icon ' + props.className} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <g id='Canvas'>
        <g id='Membership requests' clipPath='url(#clip0)'>
          <g id='Vector'>
            <path
              d='M 18.7826 0.5L 2.08696 0.5C 1.2194 0.5 0.5 1.21941 0.5 2.10537L 0.5 16.343L 4.17391 16.343L 18.7826 16.343C 19.6502 16.343 20.3696 15.6236 20.3696 14.7376L 20.3696 2.10537C 20.3696 1.21941 19.6502 0.5 18.7826 0.5Z'
              transform='translate(3.13 5.157)'
              fill='#fff'
            />
            <path
              d='M 18.7826 0.5L 2.08696 0.5C 1.2194 0.5 0.5 1.21941 0.5 2.10537L 0.5 16.343L 4.17391 16.343L 18.7826 16.343C 19.6502 16.343 20.3696 15.6236 20.3696 14.7376L 20.3696 2.10537C 20.3696 1.21941 19.6502 0.5 18.7826 0.5Z'
              strokeMiterlimit='8'
              transform='translate(3.13 5.157)'
            />
          </g>
          <g id='Vector_2'>
            <path
              d='M 18.7826 0.5L 2.08696 0.5C 1.2194 0.5 0.5 1.21941 0.5 2.10537L 0.5 16.343L 4.17391 16.343L 18.7826 16.343C 19.6502 16.343 20.3696 15.6236 20.3696 14.7376L 20.3696 2.10537C 20.3696 1.21941 19.6502 0.5 18.7826 0.5Z'
              transform='translate(0 2)'
            />
            <path
              d='M 18.7826 0.5L 2.08696 0.5C 1.2194 0.5 0.5 1.21941 0.5 2.10537L 0.5 16.343L 4.17391 16.343L 18.7826 16.343C 19.6502 16.343 20.3696 15.6236 20.3696 14.7376L 20.3696 2.10537C 20.3696 1.21941 19.6502 0.5 18.7826 0.5Z'
              strokeMiterlimit='8'
              transform='translate(0 2)'
            />
          </g>
          <path
            d='M 3.5 3.75C 4.37818 3.75 5.08454 2.91 5.08454 1.875C 5.08454 0.84 4.37818 0 3.5 0C 2.62182 0 1.90909 0.84 1.90909 1.875C 1.90909 2.91 2.62182 3.75 3.5 3.75ZM 3.5 5.25C 2.33545 5.25 0 5.94 0 7.3125L 0 9L 7 9L 7 7.3125C 7 5.94 4.66454 5.25 3.5 5.25Z'
            transform='translate(3 6)'
            fill='#fff'
            id='Vector_3'
          />
          <path
            d='M 5 0L 1.70512 3L 0 1.24994'
            strokeWidth='1.5'
            transform='translate(13 9)'
            stroke='#fff'
            id='Stroke 901'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='24' height='24' fill='#fff' transform='translate(0 .001)' />
        </clipPath>
      </defs>
    </svg>
  )
}
export default Membership



// WEBPACK FOOTER //
// ./src/components/icons/main-menu/Membership.tsx